import { CommonModule, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatListModule } from '@angular/material/list';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../shared/shared.module';
import { PendingAudioComponent } from './components/pending-audio/pending-audio.component';
import { PendingRequestsComponent } from './components/pending-requests/pending-requests.component';

const MAT_MODULES = [
  MatButtonModule,
  MatListModule
]

@NgModule({
  declarations: [
    PendingAudioComponent,
    PendingRequestsComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    RouterModule,
    FormsModule,
    //...MAT_MODULES
  ],
  providers: [DatePipe],
  exports: [PendingRequestsComponent]
})
export class PendingModule { }
